
import { Component, Vue, Prop } from "vue-property-decorator";
import store from "../../core/store";
import { ShopService } from "../../core/services/shopService";
import { Format } from "@shared/core/helpers/formatHelper";

@Component
export default class ProductCard extends Vue {
  @Prop({ required: true, type: Object }) product!: any;
  memberships: any[] = [];

  getImageProduct(name: string) {
    if (name !== undefined && name !== "" && name !== null) {
      return store.state.settings.Uploads + "/" + name;
    }
    return store.state.settings.Uploads + "/" + store.state.settings.Mainlogo;
  }

  formatCurrency(pr: any) {
    var p = store.state.settings.PriceWithTaxes ? pr.grossPrice : pr.netPrice;
    return Format.formatCurrency(p);
  }

  addToCart(p: any, e: any) {
    e.preventDefault();
    new ShopService().addProductToCart(p, 1, e.currentTarget);
  }
  buildUrlShop(product) {
    return `/shop/${product.id}`;
  }
}
